import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { GetUserAnalyticsProps, GetUsersAnalyticsReturn, OrganizationId } from "api";
import { Credentials } from "auth";
import { State } from "redux/state";

import { getString } from "utils/Utils";

export type FetchOrganizationUserAnalytics = "FETCH_ORG_USER_ANALYTICS";
export const FETCH_ORGANIZATION_USER_ANALYTICS: FetchOrganizationUserAnalytics = "FETCH_ORG_USER_ANALYTICS";
export type FetchOrganizationUserAnalyticsEnd = "FETCH_ORG_USER_ANALYTICS_END";
export const FETCH_ORGANIZATION_USER_ANALYTICS_END: FetchOrganizationUserAnalyticsEnd = "FETCH_ORG_USER_ANALYTICS_END";

export interface FetchOrganizationUserAnalyticsAction extends Action {
    payload: {
        organizationId: string;
        credentials: Credentials;
        props?: GetUserAnalyticsProps;
    };
    type: FetchOrganizationUserAnalytics;
}

export function fetchOrganizationUserAnalytics(
    organizationId: OrganizationId,
    props?: GetUserAnalyticsProps
): ThunkAction<void, State, undefined, FetchOrganizationUserAnalyticsAction> {
    return (dispatch: Dispatch<FetchOrganizationUserAnalyticsAction>, getState) => {
        const state = getState();
        dispatch(fetchOrgUserAnalyticsWithCredentials(organizationId, props, state.auth.credentials));
    };
}

function fetchOrgUserAnalyticsWithCredentials(
    organizationId: OrganizationId,
    props: GetUserAnalyticsProps,
    credentials: Credentials
): FetchOrganizationUserAnalyticsAction {
    return {
        payload: {
            credentials,
            organizationId: getString(organizationId, "organizationId"),
            props
        },
        type: FETCH_ORGANIZATION_USER_ANALYTICS
    };
}

export interface FetchOrganizationUserAnalyticsEndAction extends Action {
    payload: {
        organizationId: string;
        result?: GetUsersAnalyticsReturn;
        error?: Error;
    };
    type: FetchOrganizationUserAnalyticsEnd;
}

export function fetchOrganizationUserAnalyticsEnd(
    error: Error,
    organizationId: string,
    result?: GetUsersAnalyticsReturn
): FetchOrganizationUserAnalyticsEndAction {
    return {
        payload: {
            error,
            organizationId,
            result
        },
        type: FETCH_ORGANIZATION_USER_ANALYTICS_END
    };
}
